<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
	data() {
		return {
		}
	},
	created() {
		
	},
	methods: {
		
	}
}
</script>

<style>
</style>
